import React, { Component } from 'react';
import Hero from "../modules/Hero/Hero";
import globals from "../globals";
import FancyInput from "../elements/FancyInput";
import Button from "../elements/Button";
import queryString from "query-string";

class Login extends Component {

    constructor(props) {
        super(props);

        this.state = {
            login_name: '',
            password: ''
        }
    }

    componentDidMount() {
        globals.animatePageIn(this.container);

        let queryData = queryString.parse(this.props.location.search);
        if (queryData.u) {
             this.setState({login_name: queryData.u});
        }
    }

    handleInputChange(event) {
        const target = event.target;
        this.setState({
            [target.name]: target.value
        });
    }

    handleKeyDown(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            this.form.submit();
        }
    }

    render() {
        location.reload();
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}}>
                <Hero
                    title="Login to your account"
                    subTitle="Exetel business customers login here"
                    leadCopy={[]}
                >
                    <div className="login-form">
                        <form action="https://www.exetel.com.au/login/redirect.php" method="POST" ref={el => this.form = el}>
                            <FancyInput
                                name="login_name"
                                maxLength="50"
                                label="Username"
                                type="text"
                                value={this.state.login_name}
                                handleChange={this.handleInputChange.bind(this)}
                            />
                            <FancyInput
                                name="password"
                                maxLength="50"
                                label="Password"
                                type="password"
                                value={this.state.password}
                                handleKeyDown={this.handleKeyDown.bind(this)}
                                handleChange={this.handleInputChange.bind(this)}
                            />
                            <Button image="/images/btn-login-darkgreen.svg" alt="Login" action={() => this.form.submit()} />
                            <p>Forgot your <a href="https://www.exetel.com.au/password_recover.php" target="_blank">password</a>?</p>
                        </form>
                    </div>
                </Hero>
            </div>
        );
    }

}

export default Login;


// WEBPACK FOOTER //
// ./resources/assets/js/pages/Login.js